export default "__VITE_ASSET__BjqY4i2V__"